var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDb13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 95.39 131.07"
    },
    viewBox: "0 0 95.39 131.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.05 105.75 16.18 2.52c.2-1.27 1.18-2.26 2.44-2.48s2.52.4 3.13 1.53l16.68 31.12 6.65-12.66c.51-.98 1.53-1.59 2.64-1.59s2.12.61 2.64 1.59l45.02 85.72H.05z",
    style: {
      fill: "#ffa000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.78 65.54 38.43 32.68.05 105.75l55.73-40.21z",
    style: {
      fill: "#f57c00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.39 105.75 83.03 29.29c-.19-1.1-.97-2-2.03-2.34s-2.22-.06-3.01.73L.05 105.75l43.12 24.18a8.94 8.94 0 0 0 8.71 0l43.51-24.18z",
    style: {
      fill: "#ffca28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.03 29.29c-.19-1.1-.97-2-2.03-2.34s-2.22-.06-3.01.73L62.52 43.19 50.36 20.03c-.51-.98-1.53-1.59-2.64-1.59s-2.12.61-2.64 1.59l-6.65 12.66L21.75 1.57C21.15.44 19.88-.18 18.62.04s-2.25 1.22-2.44 2.48L.05 105.75H0l.05.06.42.21 77.49-77.58c.79-.79 1.95-1.08 3.02-.74s1.85 1.24 2.03 2.35l12.25 75.77.12-.07-12.35-76.46zM.19 105.61 16.18 3.26c.19-1.27 1.18-2.27 2.44-2.48s2.52.4 3.13 1.53l16.68 31.12 6.65-12.66c.51-.98 1.53-1.59 2.64-1.59s2.12.61 2.64 1.59l11.92 22.66L.19 105.61z",
    style: {
      fill: "#fff",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.89 129.2a8.94 8.94 0 0 1-8.71 0L.16 105.09l-.1.66 43.12 24.18a8.94 8.94 0 0 0 8.71 0l43.5-24.18-.11-.69-43.39 24.14z",
    style: {
      opacity: 0.2,
      fill: "#a52714",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -243.479,
    x2: -242.436,
    y1: 345.28,
    y2: 344.521,
    gradientTransform: "matrix(95 0 0 -130.9998 23127.441 45253.934)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.91 29.3c-.19-1.1-.97-2-2.02-2.34a2.953 2.953 0 0 0-3 .73L62.47 43.2 50.35 20.05c-.51-.98-1.53-1.59-2.63-1.59s-2.11.61-2.63 1.59l-6.63 12.66L21.84 1.6C21.24.47 19.98-.15 18.72.07s-2.24 1.22-2.43 2.48L.22 105.73l42.97 24.17a8.882 8.882 0 0 0 8.68 0l43.34-24.17-12.3-76.43z",
    style: {
      fill: "url(#a)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb13);
export default __webpack_public_path__ + "static/media/db13.980770e29537d3e43e80095e9617c4d6.svg";
export { ForwardRef as ReactComponent };